// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.softlite-tab-panel>.components-tab-panel__tabs {
    border-top: 1px solid #dedede;
    border-bottom: 1px solid #dedede;
}

.softlite-tab-setting,
.softlite-tab-style {
    transition: all .3s;
    width: 50%;
    align-items: center;
    justify-content: center;
}

.softlite-tab-setting.active-tab,
.softlite-tab-style.active-tab {
    background-color: #185ee0;
    color: #ffffff !important;
}
.softlite-text-control>div{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.softlite-text-control>div>label{
    font-weight: 400;
    text-transform: capitalize;
    margin-bottom: 0;
    font-size: 13px !important;
}
.softlite-text-control>div>label, .softlite-text-control>div>input{
    width: 50% !important;
}
.softlite-select-control .components-input-control__container {
    width: 50%;
    flex: unset;
}

.softlite-select-control-max-width .components-input-control__container {
    width: 100%;
}

.softlite-select-control label {
    font-weight: 400 !important;
    text-transform: capitalize !important;
    font-size: 13px !important;
}

.softlite-toggle-option-direction>.components-base-control:first-child {
    width: 80%;
}

.softlite-toggle-option-direction>.components-base-control:nth-child(2) {
    width: 20%;
}

.softlite-toggle-option-direction .components-toggle-group-control {
    border: 1px solid #d6cfcf;
}

.softlite-dropdow-responsive button.components-dropdown-menu__toggle {
    padding: 0;
    vertical-align: middle;
    min-width: unset;
}

.softlite-dropdow-responsive svg {
    width: 20px;
    height: 20px;
}

[data-type^="softlite-io-integration"].wp-block {
    margin-top: 0;
    margin-bottom: 0;
    margin-left: 0;
    margin-right: 0;
    max-width: 100%;
}

[data-type^="softlite-io-integration"].wp-block.softlite-block-image {
    max-width: 100% !important;
}

.block-editor-iframe__body * {
    box-sizing: border-box;
}`, "",{"version":3,"sources":["webpack://./assets/js/src/block/div/block-div.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;;IAEI,mBAAmB;IACnB,UAAU;IACV,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;;IAEI,yBAAyB;IACzB,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,gBAAgB;IAChB,0BAA0B;AAC9B;AACA;IACI,qBAAqB;AACzB;AACA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,2BAA2B;IAC3B,qCAAqC;IACrC,0BAA0B;AAC9B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;AAC1B","sourcesContent":[".softlite-tab-panel>.components-tab-panel__tabs {\r\n    border-top: 1px solid #dedede;\r\n    border-bottom: 1px solid #dedede;\r\n}\r\n\r\n.softlite-tab-setting,\r\n.softlite-tab-style {\r\n    transition: all .3s;\r\n    width: 50%;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.softlite-tab-setting.active-tab,\r\n.softlite-tab-style.active-tab {\r\n    background-color: #185ee0;\r\n    color: #ffffff !important;\r\n}\r\n.softlite-text-control>div{\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n.softlite-text-control>div>label{\r\n    font-weight: 400;\r\n    text-transform: capitalize;\r\n    margin-bottom: 0;\r\n    font-size: 13px !important;\r\n}\r\n.softlite-text-control>div>label, .softlite-text-control>div>input{\r\n    width: 50% !important;\r\n}\r\n.softlite-select-control .components-input-control__container {\r\n    width: 50%;\r\n    flex: unset;\r\n}\r\n\r\n.softlite-select-control-max-width .components-input-control__container {\r\n    width: 100%;\r\n}\r\n\r\n.softlite-select-control label {\r\n    font-weight: 400 !important;\r\n    text-transform: capitalize !important;\r\n    font-size: 13px !important;\r\n}\r\n\r\n.softlite-toggle-option-direction>.components-base-control:first-child {\r\n    width: 80%;\r\n}\r\n\r\n.softlite-toggle-option-direction>.components-base-control:nth-child(2) {\r\n    width: 20%;\r\n}\r\n\r\n.softlite-toggle-option-direction .components-toggle-group-control {\r\n    border: 1px solid #d6cfcf;\r\n}\r\n\r\n.softlite-dropdow-responsive button.components-dropdown-menu__toggle {\r\n    padding: 0;\r\n    vertical-align: middle;\r\n    min-width: unset;\r\n}\r\n\r\n.softlite-dropdow-responsive svg {\r\n    width: 20px;\r\n    height: 20px;\r\n}\r\n\r\n[data-type^=\"softlite-io-integration\"].wp-block {\r\n    margin-top: 0;\r\n    margin-bottom: 0;\r\n    margin-left: 0;\r\n    margin-right: 0;\r\n    max-width: 100%;\r\n}\r\n\r\n[data-type^=\"softlite-io-integration\"].wp-block.softlite-block-image {\r\n    max-width: 100% !important;\r\n}\r\n\r\n.block-editor-iframe__body * {\r\n    box-sizing: border-box;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
